export default __webpack_public_path__ + "static/media/obj5.63885992.jpg";